import type { PropsWithChildren, ReactNode } from 'react'
import styled from '@xstyled/styled-components'
import type { HeaderWithAvatarProps } from '../shared'
import { HeaderWithAvatar } from '../shared'

export interface UnauthenticatedLandingLayoutProps
  extends Pick<
    HeaderWithAvatarProps,
    'signUpLinkText' | 'signInLinkText' | 'linkVisibility'
  > {
  headerContent?: ReactNode
}

export const UnauthenticatedLandingLayout = (
  props: PropsWithChildren<UnauthenticatedLandingLayoutProps>
): JSX.Element => {
  return (
    <Root>
      <HeaderWithAvatar
        breakpoint={768}
        dataTestId='landing-unauthenticated-nav-header'
        linkVisibility={props.linkVisibility}
        signUpLinkText={props.signUpLinkText}
        signInLinkText={props.signInLinkText}
        bg='grey.l4'
        rightContent={props.headerContent}
      />
      {props.children}
    </Root>
  )
}

const Root = styled.div(props => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gridTemplateRows: 'auto 1fr',
  minHeight: '100%',
  backgroundColor: props.theme.colors.grey.l4
}))
